<form #step2form="ngForm" class="editForm customMat" novalidate>
    <div class="tab-pane fade in active">
        <div class="flex-center">
            <button fxHide [fxShow.gt-xs]="true" mat-raised-button class="back" (click)="goToPrevious(step2form);$event.preventDefault();">< zurück</button>
            <h4 class="sub">{{title}}</h4>
            <button fxHide [fxShow.gt-xs]="true" mat-raised-button class="next" [disabled]="!testForm.valid" (click)="goToNext(step2form);$event.preventDefault();">weiter ></button>
        </div>
        <div class='row'>
            <div class='col-xs-offset-1 col-xs-10'>
                <div class="row flex-strech">
                    <div class='col-xs-12 col-sm-6'>
                        <div class="item">
                            <img src="assets/images/icon_wohnflaeche.png" class="box-image" />
                            <p class="sub">Wohnfläche in m<sup>2</sup></p>

                            <mat-slider
                                [disabled]="disabled"
                                [invert]="invert"
                                [max]="max"
                                [min]="min"
                                [step]="step"
                                [thumbLabel]="thumbLabel"
                                [(ngModel)]="size.livingspace"
                                [vertical]="vertical"
                                name="slider1"
                                required>
                            </mat-slider>
                            
                            <div class="flex-space-around">
                                <span>&#60; 50m<sup>2</sup></span>
                                <span>&#62; 500m<sup>2</sup></span>
                            </div>

                            <div [formGroup]="testForm">
                                <mat-form-field class="">
                                    <mat-label>Alternativ eingeben</mat-label>
                                    <input matInput class="larger-text" type="text" (keydown)="check($event)"  [(ngModel)]="size.livingspace" #livingspace formControlName="livingspace" maxlength="5" required>
                                    <div class="custom-suffix max-width-80-percent" [style.width.px] = "50 + ( 13 * livingspace.value.length)">
                                        <span matSuffix>m<sup>2</sup></span>
                                    </div>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class='col-xs-12 col-sm-6'>
                        <div class="item">
                            <img src="assets/images/icon_room.png" class="box-image" />
                            <p class="sub">Zimmeranzahl</p>

                            <mat-slider
                                [disabled]="disabled"
                                [invert]="invert"
                                [max]="max2"
                                [min]="min2"
                                [step]="step"
                                [thumbLabel]="thumbLabel"
                                [(ngModel)]="size.room"
                                [vertical]="vertical"
                                name="slider2"
                                required>
                            </mat-slider>
                            
                            <div class="flex-space-around">
                                <span>1</span>
                                <span>10</span>
                            </div>

                            <div [formGroup]="testForm">
                                <mat-form-field class="">
                                    <mat-label>Alternativ eingeben</mat-label>
                                    <input class="larger-text" matInput type="text" (keydown)="check($event)" [(ngModel)]="size.room" name="field2" formControlName="room" maxlength="2" required>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-center">
            <button fxShow [fxHide.gt-xs]="true" mat-raised-button class="back" (click)="goToPrevious(step2form);$event.preventDefault();">< zurück</button>
            <button fxShow [fxHide.gt-xs]="true" mat-raised-button class="next" [disabled]="!testForm.valid" (click)="goToNext(step2form);$event.preventDefault();">weiter ></button>
        </div>
    </div>
  </form>
  <app-footer [progress]="40"></app-footer>